import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9740cfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guild-0" }
const _hoisted_2 = { class: "guild--left" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex\" data-v-e9740cfc><div class=\"guild-0-icon\" data-v-e9740cfc></div><div class=\"guild-0-txt\" data-v-e9740cfc><div class=\"guild-0-txt--1\" data-v-e9740cfc>谷歌浏览器</div><div class=\"guild-0-txt--2\" data-v-e9740cfc>推荐浏览器，性能稳定，兼容性好</div></div></div>", 1)
const _hoisted_4 = { class: "guild-0-btns" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下载安装")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("已安装（跳过)")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "guild--right" }, [
  /*#__PURE__*/_createElementVNode("div", null, "安装完成后，请在电脑桌面打开\"谷歌浏览器\"，"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("复制地址"),
    /*#__PURE__*/_createElementVNode("span", { class: "guild--right-link" }, "msp.zto.com"),
    /*#__PURE__*/_createTextVNode("粘贴到浏览器地址栏中")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "guild--right-img" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          class: "system-btn",
          type: "primary",
          size: "mini",
          onClick: _ctx.handleDown
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          class: "system-btn",
          size: "mini",
          onClick: _ctx.handleSkip
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _hoisted_7
  ]))
}